import { ReduxState } from '../../state';
import { SubscribeModalsState } from './state';

export const selectSubscribeModals = (
  state: ReduxState
): SubscribeModalsState => state.SubscribeModals;
